import { resolveId } from '@medplum/core'
import type { ExtractResource, ResourceType } from '@medplum/fhirtypes'
import { type FhirValue, getType, parseReferenceString } from '@seen/core/utils'
import type { UseQueryResult } from '@tanstack/react-query'
import { useFhirRead } from '#src/hooks/useFhirRead.ts'

export function useResource<T extends ResourceType>(
  value: FhirValue<T> | string | null | undefined
): UseQueryResult<ExtractResource<T>> {
  let fhirValue: FhirValue<T> | null | undefined
  if (typeof value === 'string') {
    fhirValue = parseReferenceString(value)
  } else {
    fhirValue = value
  }

  const type = getType(fhirValue ?? undefined)
  const id = resolveId(fhirValue ?? undefined)

  const queryResult = useFhirRead(type, id, {
    query: {
      enabled: Boolean(type) && Boolean(id),
      meta: {
        resourceType: type,
        queryParams: {
          _id: id,
        },
      },
    },
  })

  return queryResult
}
